import Container from "Components/Container/Container";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import htmlToText from "Helpers/HtmlToText";

// fetching
import useFetch from "Hooks/useFetch";
import IsLoading from "Components/RequestHandler/IsLoading";
import IsError from "Components/RequestHandler/IsError";

const BlogDetailed = () => {
  const { slug } = useParams();
  const { data, loading, error, fetchData } = useFetch(`blogs/${slug}`);

  useEffect(() => {
    fetchData();
  }, [slug]);

  if (loading) return <IsLoading />;
  else if (error) return <IsError />;
  else if (data) {
    const blogData = data?.BlogsData[0];
    return (
      <main>
        <section className="pt-36 pb-12 lg:pt-40 lg:pb-16 bg-blue text-white">
          <Container>
            <p className="text-4xl font-segu text-white">{blogData?.name}</p>
          </Container>
        </section>

        <section className="mt-secondary lg:-mt-10 mb-primary">
          <Container>
            <div className="">
              <img
                className="w-full max-h-[500px] object-cover"
                src={blogData?.image}
                alt=""
              />
            </div>

            <div className="mt-secondary font-segu lg:w-3/4 mx-auto">
              <p className="text-3xl capitalize font-[600]">{blogData?.name}</p>
              <p className="text-lg text-[#8b8b8b] italic">{blogData?.date}</p>
              <p className="text-xl mt-2">{blogData?.subTitle}</p>
              <p className="mt-4">{htmlToText(blogData?.description)}</p>
            </div>
          </Container>
        </section>
      </main>
    );
  }
};

export default BlogDetailed;
